<template>
  <div class="customer-inter-wrapper" v-animate-css="'fadeIn'">
    <div class="instruct-list">
      <div class="instruct-header">
        <div class="search-add-btn-widget">
          <div class="search-widget">
            <img src="@/assets/icons/search.svg" alt />
            <input
              v-model="search_student_input"
              type="text"
              placeholder="Type in to Search…"
            />
          </div>
        </div>

        <div class="filter-widget"></div>
      </div>
      <div class="instruct-body">
        <table class="table-data" v-if="student_data.length > 0">
          <thead class="table-header">
            <tr class="stack-title">
              <th class="stick-title" width="200">
                <div class="force-start">Name</div>
              </th>
              <th class="stick-title">LIA</th>
              <th class="stick-title" width="100">Start date</th>
              <th class="stick-title">Contract</th>
              <th class="stick-title" width="20"></th>
            </tr>
          </thead>
          <tbody class="table-body">
            <template>
              <tr
                v-for="(item, index) in student_data"
                :key="index"
                class="row-data"
              >
                <td>
                  <div class="student-profile-widget">
                    <img src="@/assets/icons/logo_avatar.svg" alt="" />
                    <div class="student-info">
                      <label>
                        {{
                          (item.first_name + " " + item.last_name) | validate
                        }}</label
                      >
                      <div
                        class="school-profile-widget"
                        @click="viewStudent(student)"
                        v-for="(school, i) in item.school"
                        :key="i"
                      >
                        <label class="class-name">{{ school.name }}</label>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <div class="internship-name">{{ item.internship.name }}</div>
                </td>

                <td>
                  {{ item.created_at | formatDate }}
                </td>
                <td>
                  <div class="row-action">
                    <button
                      class="btn-approve"
                      v-if="!item.contract || !item.profile.has_contract"
                      :class="{ disabled: !item.contract }"
                      @click="sendContract(item)"
                    >
                      Send Contract
                    </button>

                    <div
                      v-if="item.contract && item.profile.has_contract"
                      class="approve-status"
                    >
                      Contract Sent
                    </div>
                    <button
                      v-if="!item.contract"
                      @click="showAttachContractModal(item)"
                      class="btn-attach"
                    >
                      <img src="@/assets/icons/attach-icon.svg" />
                    </button>
                    <div v-if="item.contract" class="attached-file">
                      <app-dialog
                        title="Remove Contract"
                        ask="Are you sure? This contract will be removed"
                        yesText="Remove"
                        noText="Cancel"
                        @onComfirm="removeContract(item)"
                      >
                        <button class="remove-btn">&times;</button>
                      </app-dialog>

                      <img src="@/assets/icons/attached-file.svg" />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="row-action">
                    <button
                      v-if="!item.profile.internship_started"
                      class="btn-approve"
                      :class="{ disabled: !item.contract }"
                      @click="markStudentAsStarted(item)"
                    >
                      Start
                    </button>
                    <div v-else class="start-status">Working</div>
                    <dropdown-menu class="table-menu">
                      <ul>
                        <li>
                          <a @click.prevent="gotoProfile(item, 'people')"
                            >View Candidate Profile</a
                          >
                        </li>
                        <li>
                          <a
                            @click.prevent="
                              gotoProfile(item.school[0], 'companies')
                            "
                            >View School Profile</a
                          >
                        </li>
                        <li>
                          <a @click.prevent="sendMessage(item, 'student')"
                            >Contact Candidate</a
                          >
                        </li>
                        <li>
                          <a
                            @click.prevent="
                              sendMessage(item.school[0], 'school')
                            "
                            >Contact School</a
                          >
                        </li>
                      </ul>
                    </dropdown-menu>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div v-else></div>
      </div>
    </div>

    <!-- Sent Contract Modal -->
    <div class="overlay" v-if="show_send_contract_modal">
      <div class="form-widget-modal add-internship-modal">
        <div class="moder-header">
          <h4>Attach Contract</h4>
          <div class="options"></div>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <upload
              caption="Attach Contract below in .pdf, .doc"
              remove_caption="Remove file"
              @onFileSelected="
                (file) => {
                  if (file) {
                    contract_form.file = file;
                  } else {
                    contract_form.file = null;
                  }
                }
              "
            />
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            :loading="send_contract_loading"
            @click="attachContract()"
            class="btn-save"
            >Attach</c-button
          >
          <button @click="show_send_contract_modal = false" class="btn-cancel">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dropdownMenu from "@/components/Partials/dropdownMenu";
import upload from "@/components/Partials/Uploader.vue";
export default {
  name: "intern-widget",
  components: {
    dropdownMenu,
    upload,
  },
  props: {},
  data: () => {
    return {
      student_data: [],
      send_contract_loading: false,
      search_student_input: "",
      contract_form: {
        file: null,
        student_id: null,
        school_id: null,
      },
      show_send_contract_modal: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getStudentData();
  },
  watch: {
    search_student_input(val) {
      let vm = this;
      vm.searchStudent(val);
    },
  },
  methods: {
    markStudentAsStarted(item) {
      let vm = this;
      vm.$store
        .dispatch("CUSTOMER_MARK_STUDENT_AS_STARTED", {
          user_id: item.id,
          internship_id: item.internship.id,
        })
        .then((response) => {
          vm.getStudentData();
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Now student is marked as started",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.send_contract_loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    attachContract() {
      let vm = this;
      let form_data = new FormData();
      form_data.append(
        "file",
        vm.contract_form.file,
        vm.contract_form.file.name
      );
      form_data.append("student_id", vm.contract_form.student_id);
      form_data.append("school_id", vm.contract_form.school_id);
      vm.send_contract_loading = true;
      vm.$store
        .dispatch("CUSTOMER_ATTACH_CONTRACT", form_data)
        .then((response) => {
          vm.send_contract_loading = false;
          vm.show_send_contract_modal = false;
          vm.getStudentData();
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Contract was attached",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.send_contract_loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    sendContract(item) {
      let vm = this;
      if (item.contract) {
        vm.$store
          .dispatch("CUSTOMER_SEND_CONTRACT", {
            student_id: item.id,
            school_id: item.school[0].id,
          })
          .then((response) => {
            vm.getStudentData();
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Contract was sent",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Something went wrong, try again",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    removeContract(item) {
      let vm = this;
      vm.$store
        .dispatch("CUSTOMER_REMOVE_CONTRACT", {
          student_id: item.id,
          school_id: item.school[0].id,
        })
        .then((response) => {
          vm.getStudentData();
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Contract was removed",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    showAttachContractModal(item) {
      let vm = this;
      vm.contract_form = {
        file: null,
        student_id: item.id,
        school_id: item.school[0].id,
      };
      vm.show_send_contract_modal = true;
    },
    searchStudent(quely) {
      let vm = this;
      vm.$store
        .dispatch("CUSTOMER_SEARCH_MY_STUDENT", {
          quely: quely,
        })
        .then((response) => {
          vm.student_data = response.data;
        })
        .catch((error) => {});
    },
    getStudentData() {
      let vm = this;
      vm.$store
        .dispatch("CUSTOMER_GET_MY_STUDENT")
        .then((response) => {
          vm.student_data = response.data;
        })
        .catch((error) => {});
    },
    gotoProfile(item, type) {
      let vm = this;
      if (type == "people") {
        if (item.account_type == 1) {
          vm.$router.push({
            path: "/user/profile/" + item.id,
          });
        } else if (item.account_type == 2) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "customer-public-profile",
            params: { name: name },
          });
        } else if (item.account_type == 3) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "consultant-public-profile",
            params: { name: name },
          });
        } else if (item.account_type == 4) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "consultant-public-profile",
            params: { name: name },
          });
        }
      } else if (type == "companies") {
        let item_id = window.btoa(item.id);
        let name = item.name.toLowerCase().replace(/\s/g, "-") + "-" + item_id;
        vm.$router.push({
          name: "supplier-public-profile",
          params: { name: name },
        });
      } else if (type == "assignments") {
        let item_id = window.btoa(item.id);
        let name = item.title.toLowerCase().replace(/\s/g, "-") + "-" + item_id;
        vm.$router.push({
          name: "assignment-public-profile",
          params: { name: name },
        });
      }
    },
    sendMessage(item, type) {
      let vm = this;
      if (type == "school") {
        let obj = {
          id: item.pivot.user_id,
        };
        vm.$emit("message", item);
      } else {
        vm.$emit("message", item);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-inter-wrapper {
  padding-top: 10px;
  width: 800px;
  border-radius: 5px;
  @media only screen and (max-width: 600px) {
    padding-top: 0px;
    width: 100%;
  }
  .instruct-list {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: calc(100% - 300px);
    width: 100%;
    border-radius: 5px;
    background: #fff;
    .instruct-header {
      height: 70px;
      .search-add-btn-widget {
        padding: 15px 10px;
        display: grid;
        grid-column-gap: 20px;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;

        .search-widget {
          border: 3px solid #d8d8d8;
          height: 45px;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;
          img {
            width: 25px;
            height: 25px;
          }
          input {
            height: 30px;
            width: 100%;
            padding-left: 15px;
            outline: none;
            border: none;
          }
        }
        .add-btn {
          width: 191px;
          height: 45px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          opacity: 1;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            margin-left: 10px;
          }
        }
      }
      .school-widget {
        padding: 0px 10px;
        padding-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        h2 {
          margin: 0px;
          font-size: 18px;
        }
        .table-options {
          display: flex;
          align-items: center;
          .btn-invite {
            width: 130px;
            height: 33px;
            background: #0884af;
            border-radius: 5px;
            color: #fff;
            margin-right: 10px;
          }
          .btn-approve {
            width: 110px;
            height: 33px;
            background: #1ba5a4;
            border-radius: 5px;
            color: #fff;
          }
          .start-status {
            width: 110px;
            height: 33px;
            border: 1px solid #1ba5a4;
            border-radius: 5px;
            color: #1ba5a4;
          }

          .table-menu {
          }
        }
      }
      .filter-widget {
        display: flex;
        padding: 0px 10px;
        justify-content: space-between;
        .filter-title {
          color: rgb(156, 156, 156);
        }
        .filter-select-widget {
          display: flex;
          align-items: center;
          cursor: pointer;
          .filter-selected-label {
            span {
              color: #0884af;
            }
          }
        }
      }
    }
    .instruct-body {
      padding: 10px 10px;
      padding-top: 0px;
      padding-bottom: 60px;
      .table-data {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
        tr {
          &.row-data {
            background: #fff;
          }
          &:hover {
            background: rgb(248, 248, 248);
            cursor: pointer;
          }

          th {
            border-bottom: none;
            padding: 10px 3px !important;
            text-align: left;
            color: #334d6eb0;
            font-size: 12px;
            &.stick-title {
              position: sticky;
              top: 0px;
              background: #fff;
              z-index: 999;
            }
            &.center {
              display: flex;
              align-content: center;
              input {
                position: relative;
                top: 0px;
                margin-right: 5px;
                margin: 0px 20px;
              }
            }
            .force-start {
              display: flex;
              align-items: center;
              input {
                position: relative;
                top: -1px;
                left: -7px;
                margin-right: 5px;
              }
            }
            &.text-center {
              text-align: center;
            }
          }
          td {
            text-align: left;
            border-bottom: none;
            padding: 8px 3px;
            font-size: 13px;
            color: rgb(28, 28, 28);
            border-bottom: 1px solid #ebeff2;
            .checkbox {
              position: relative;
              top: -1px;
              left: -7px;
              margin-right: 5px;
            }
            .row-action {
              display: flex;
              align-items: center;
            }
            .btn-attach {
              height: 35px;
              width: 35px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 5px;
              background: #eeeeee;
              margin: 0px 5px;
              img {
                width: 15px;
              }
            }
            .attached-file {
              height: 35px;
              width: 35px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 5px;
              background: #eeeeee;
              margin: 0px 5px;
              position: relative;
              .remove-btn {
                background: #7e0000;
                color: #fff;
                position: absolute;
                top: -3px;
                right: -3px;
                height: 18px;
                width: 18px;
                border-radius: 6px;
              }
              img {
                width: 15px;
              }
            }
            .student-profile-widget {
              display: flex;
              align-items: center;
              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                margin-right: 10px;
              }
              label {
                margin: 0px;
              }
              .student-info {
                display: flex;
                flex-direction: column;
                .school-profile-widget {
                  .class-name {
                    font-size: 10px;
                    color: rgb(77, 77, 77);
                  }
                }
              }
            }
            .school-profile-widget {
              display: flex;
              align-items: center;
              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                margin-right: 10px;
              }
              label {
                margin: 0px;
              }
            }

            .profile-content {
              display: flex;
              align-items: center;
              .profile-alphabet {
                margin-right: 5px;
                height: 30px !important;
                width: 30px !important;
                background: #1ba5a4;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                span {
                  font-size: 10px;
                  color: #fff;
                }
              }
            }

            .internship-name {
              width: 100%;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .invitation-status {
              padding: 8px 10px;
              width: 130px;
              border-radius: 5px;
              text-align: center;
              &.received {
                border: 1px solid #1ba5a4;
                color: #1ba5a4;
              }
              &.sent {
                border: 1px solid #0884af;
                color: #0884af;
              }
            }
            .approve-status {
              width: 110px;
              height: 33px;
              border: 1px solid #0884af;
              border-radius: 5px;
              color: #0884af;
            }
            .approve-status {
              padding: 8px 10px;
              width: 110px;
              border-radius: 5px;
              text-align: center;
              span {
                margin-right: 5px;
              }
              &.approved {
                border: 1px solid #1ba5a4;
                color: #1ba5a4;
              }
            }
            .progress-widget {
              width: 80px;
            }
            .table-menu {
              position: relative;
            }
            .center {
              display: flex;
              justify-content: center;
            }
            &:first-child {
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
            }
            &:last-child {
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
            }

            &.text-center {
              text-align: center;
            }
            &.email {
              color: #334d6eb0;
              font-size: 12px;
            }
            .btn-invite {
              width: 130px;
              height: 33px;
              background: #0884af;
              border-radius: 5px;
              color: #fff;
            }
            .btn-approve {
              width: 110px;
              height: 33px;
              background: #1ba5a4;
              border-radius: 5px;
              color: #fff;
              &.disabled {
                background: #c4c4c4;
                color: #fff;
                cursor: not-allowed;
              }
            }
            .start-status {
              width: 110px;
              height: 33px;
              border: 1px solid #1ba5a4;
              border-radius: 5px;
              color: #1ba5a4;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
}

.overlay {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 99999999999999;
  display: block;
  background: rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  padding-top: 80px;
  padding-bottom: 50px;
  @media (min-width: 300px) and (max-width: 630px) {
    display: unset;
    align-items: unset;
    background: #f5f5f5;
  }
  .form-widget-modal {
    background: #f5f5f5;
    border-radius: 5px;
    padding: 40px 53px;
    margin: 0 auto;
    &.add-internship-modal {
      width: 600px;
    }
    @media (min-width: 300px) and (max-width: 630px) {
      padding: 15px 23px;
      width: 100% !important;
      padding-bottom: 20px;
      display: inline-table;
    }
    .moder-header {
      margin-top: 0px;
      margin-bottom: 25px;
      h4 {
        font-size: 30px;

        margin: 0px;
        @media (min-width: 300px) and (max-width: 630px) {
          font-size: 18px;
        }
      }
    }
    .modal-body {
      .modal-divider {
        display: grid;
        grid-template-columns: 63% 35%;
        grid-column-gap: 20px;
        .form-part {
        }
        .date-picker-part {
        }
      }
      .twin-input {
        display: grid;
        grid-column-gap: 20px;
        grid-template-columns: 47% 47%;
        @media (min-width: 300px) and (max-width: 630px) {
          grid-template-columns: 100%;
        }
      }
      .input-group {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        label {
          font-size: 13px;
          display: block;
          margin-bottom: 10px;
        }
        .input-header {
          display: flex;
          justify-content: space-between;
          .option {
            display: flex;
            align-items: center;
            span {
              margin-top: 4px;
            }
          }
        }
        .choose-widget {
          display: flex;
          border: 1px solid #ddd;
          border-radius: 5px;
          .choose-item {
            width: 33.3333%;
            height: 45px;
            font-size: 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #ddd;
            cursor: pointer;
            &.active {
              background: #04a5a5;
              color: #fff;
            }
          }
        }
        .radio-input {
          height: 45px;
          display: flex;
          align-items: center;
          .item {
            margin-right: 20px;
          }
        }
        .input-form {
          height: 47px;
          border: 1px solid #ddd;
          border-radius: 5px;
          outline: none;
          padding: 0px 15px;
        }
        .upload-input {
          height: 100px;
        }
        select {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
        }
        textarea.input-form {
          height: 100px;
          border: 1px solid #ddd;
          border-radius: 5px;
          outline: none;
          padding: 10px 15px;
          resize: none;
        }
      }
    }
    .modal-footer {
      margin-top: 20px;
      display: flex;
      .btn-save {
        background: #24a5a5;
        height: 50px;
        width: 125px;
        color: #fff;
        outline: none;
        border: none;
        border-radius: 5px;
        margin-right: 15px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .btn-cancel {
        background: transparent;
        height: 50px;
        width: 57px;
        color: #24a5a5;
        outline: none;
        border: none;
        border-radius: 5px;
        margin-right: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>
